// API 配置
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://cloudflare-photo-album-api.china-al.workers.dev'

// 其他配置
export const DEFAULT_ADMIN_USERNAME = 'admin'
export const DEFAULT_ADMIN_PASSWORD = 'admin123'

// 上传限制
export const MAX_FILE_SIZE = 100 * 1024 * 1024 // 100MB
export const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
